import { FC } from 'react';
import { AnimatedShape, Box } from '@altermaind/web/ui';

export const SkeletonForm: FC = () => {
  return (
    <Box
      p='none'
      shadow='soft'
      borderRadius='xs'
      display='flex'
      flexDirection='column'
      width='100%'
    >
      <Box>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape variant='round' width={120} height={15} />
        <AnimatedShape mt='xxs' variant='round' width='100%' height={44} />
      </Box>
      <Box mt='s'>
        <AnimatedShape mt='xxs' variant='round' width={120} height={44} />
      </Box>
    </Box>
  );
};
